/** 登录密码有效期：90 天过期；最近 10 天每次登录弹窗提醒 */
export const PASSWORD_VALID_DAYS = 90
export const PASSWORD_REMIND_LAST_DAYS = 10

const REMIND_SESSION_PREFIX = 'pwd_expire_remind_login_'

export function formatPasswordDateTime(v: unknown): string {
  if (v == null || v === '') return '—'
  const s = String(v).trim()
  if (!s) return '—'
  if (s.length >= 16) return s.slice(0, 16).replace('T', ' ')
  return s
}

export function shouldShowPasswordExpireRemind(opts: {
  expired?: boolean | null
  remainDays?: number | null
}): boolean {
  if (opts.expired) return true
  if (opts.remainDays == null) return false
  return opts.remainDays <= PASSWORD_REMIND_LAST_DAYS
}

function sessionKey(token: string): string {
  return `${REMIND_SESSION_PREFIX}${token}`
}

/** 本次登录是否已提醒过（刷新页面不重复弹，重新登录再弹） */
export function hasPasswordExpireRemindedThisLogin(token: string): boolean {
  if (!token) return true
  try {
    return Boolean(sessionStorage.getItem(sessionKey(token)))
  } catch {
    return false
  }
}

export function markPasswordExpireRemindedThisLogin(token: string): void {
  if (!token) return
  try {
    sessionStorage.setItem(sessionKey(token), '1')
  } catch {
    // 隐私模式等忽略
  }
}

/** 退出登录时清掉本会话的改密提醒标记 */
export function clearPasswordExpireRemindSession(): void {
  try {
    const keys: string[] = []
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const k = sessionStorage.key(i)
      if (k && k.startsWith(REMIND_SESSION_PREFIX)) keys.push(k)
    }
    keys.forEach((k) => sessionStorage.removeItem(k))
  } catch {
    // 隐私模式等忽略
  }
}
